import { apiAxios } from "../../apiConfig";

export const getDashboardCounts = async () => {
  try {
    const response = await apiAxios.get("/dashboard/counts");

    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard counts:", error);
    throw error;
  }
};

export const getEmailSignups = async () => {
  try {
    const response = await apiAxios.get("/emails");

    return response.data;
  } catch (error) {
    console.error("Error fetching email signups:", error);
    throw error;
  }
};

export const getVolunteers = async () => {
  try {
    const response = await apiAxios.get("/volunteers");

    return response.data;
  } catch (error) {
    console.error("Error fetching volunteers:", error);
    throw error;
  }
};
